export default __webpack_public_path__ + "static/media/logoapdp.2f7b458e.svg";